import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=01577040&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdditionalInfo.vue?vue&type=style&index=0&id=01577040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01577040",
  null
  
)

export default component.exports